/* eslint-disable react/no-danger */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import {
  ArrowLink,
  ExpandableLink,
  CloudinaryPicture,
} from '@bwoty-web/ui-kit';
import { useGlobals } from '@bwoty-web/ui-kit/hooks';

import './partInfo.scss';

const imageSizes = [
  {
    width: 1224,
    breakpoint: 1024,
  },
  {
    width: 1024,
    breakpoint: 768,
  },
  {
    width: 768,
    breakpoint: 415,
  },
];

const PartInfo = ({
  roomType,
  texts = {},
  toggleRoomInfo,
  showPartInfoRoomList,
}) => {
  const [showAllRooms, setShowAllRooms] = useState(false);
  const { hotelHasParts } = useGlobals();

  useEffect(() => {
    const popupBody = document.getElementsByClassName(
      'gw-room-type-popup--scroll-anchor',
    );
    if (popupBody && popupBody.length) {
      popupBody[0].scrollIntoView();
    }
  }, [roomType?.meta?.id]);

  if (!roomType || !roomType?.part || !hotelHasParts) {
    return null;
  }

  return (
    <div className="gw-part-info">
      <h3 className="gw-part-info__name">{roomType?.part?.name}</h3>
      {roomType?.part?.texts?.description && (
        <div
          className="gw-part-info__description"
          dangerouslySetInnerHTML={{
            __html: roomType?.part?.texts?.description,
          }}
        />
      )}
      <div className="gw-part-info__table-heading">
        {texts?.roomTypePopupPlacementHeading}
      </div>
      <div>
        {(roomType?.part?.floorPlan?.roomsShort || [])
          .filter((rt) => rt.id === roomType?.meta?.id)
          .map((rt) => (
            <div key={rt.id} className="gw-part-info__room">
              {roomType?.mapColorCode && (
                <div
                  className="gw-part-info__room-color"
                  style={{ backgroundColor: roomType.mapColorCode }}
                />
              )}
              <div className="gw-part-info__room-text">{rt.name}</div>
            </div>
          ))}
        {showPartInfoRoomList && (
          <>
            {showAllRooms &&
              (roomType?.part?.floorPlan?.roomsShort || [])
                .filter((rt) => rt.id !== roomType?.meta?.id)
                .map((rt) => (
                  <div
                    key={uniqid('gw-part-info-button-')}
                    className="gw-part-info__room"
                  >
                    <div
                      className="gw-part-info__room-color"
                      style={{
                        backgroundColor: rt?.mapColorCode || 'transparent',
                      }}
                    />
                    <ArrowLink
                      name="roomButton"
                      onClick={() => toggleRoomInfo(rt.id)}
                    >
                      {rt.name}
                    </ArrowLink>
                  </div>
                ))}
            <ExpandableLink
              isOpen={showAllRooms}
              className="gw-part-info__expand-link"
              onClick={() => setShowAllRooms(!showAllRooms)}
            >
              {showAllRooms
                ? texts?.roomTypePopupShowLess
                : texts?.roomTypePopupShowMore}
            </ExpandableLink>
          </>
        )}
        {roomType?.roomMapImage && (
          <div className="gw-part-info__images">
            <CloudinaryPicture
              img={{
                cloudinaryUriTemplate:
                  roomType?.roomMapImage?.cloudinaryUriTemplate,
              }}
              sizes={imageSizes}
            />
          </div>
        )}
      </div>
    </div>
  );
};

PartInfo.propTypes = {
  roomType: PropTypes.shape({
    meta: PropTypes.shape({
      id: PropTypes.number,
    }).isRequired,
    part: PropTypes.shape({
      name: PropTypes.string,
      texts: PropTypes.shape({
        description: PropTypes.string,
      }),
      floorPlan: PropTypes.shape({
        roomsShort: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            image: PropTypes.shape({
              src: PropTypes.string,
            }),
          }),
        ),
      }),
    }),
    mapColorCode: PropTypes.string,
    roomMapImage: PropTypes.shape({
      cloudinaryUriTemplate: PropTypes.string,
    }),
  }).isRequired,
  texts: PropTypes.shape({
    roomTypePopupPlacementHeading: PropTypes.string,
    roomTypePopupShowLess: PropTypes.string,
    roomTypePopupShowMore: PropTypes.string,
  }),
  toggleRoomInfo: PropTypes.func.isRequired,
  showPartInfoRoomList: PropTypes.bool.isRequired,
};

export default PartInfo;
